<?php

Namespace Controller;

class JobListController extends \Controller\Base
{

    public function execute($pageVars)
    {
        $page_model = new \Model\JobList\PageModel();
        $default_page_model = new \Model\DefaultModule\PageModel();
        $page = $page_model->getPage($pageVars);
        \ISOPHP\js_core::$console->log('Job List pagevars', $pageVars);
        \ISOPHP\js_core::$console->log('Yes Here is action params....:', $pageVars['route']['action']);
        \ISOPHP\js_core::$window->document->title = $page['title'];
        $res = new \Controller\Result();

        $res->page = $page;
        $res->view = 'JobList.php';
        $res->type = 'view';
        $res->view_control = 'JobList';
        $res->post_template = array();

        if ($pageVars['route']['action'] == 'details') {
            $res->post_template[] = $page_model->showJobDetails($pageVars);
            $res->post_template[] = $page_model->showLastLogin($pageVars);
        } else if ($pageVars['route']['action'] == 'profile') {
            $res->post_template[] = $page_model->showEmployerDetails($pageVars);
        } else if ($pageVars['route']['action'] == 'show-to-user') {
            $res->post_template[] = $page_model->showJobListToUser($pageVars);
            $res->post_template[] = $page_model->showLastLogin($pageVars);
        } else if ($pageVars['route']['action'] == 'save-favorite') {
            $data = $page_model->addToFavorite($pageVars);
            \ISOPHP\js_core::$console->log('Add Favorite Data', $data);
            $res->type = null;
            return $res;
        } else if ($pageVars['route']['action'] == 'remove-favorite') {
            $data = $page_model->removeFromFavorite($pageVars);
            \ISOPHP\js_core::$console->log('Remove Favorite Data', $data);
            $res->type = null;
            return $res;
        } else if ($pageVars['route']['action'] == 'show-user-favorite') {
            $res->post_template[] = $page_model->showFavoriteListToUser($pageVars);
            $res->post_template[] = $page_model->showLastLogin($pageVars);
        } else if ($pageVars['route']['action'] == 'show-user-applied') {
            $res->post_template[] = $page_model->showAppliedListToUser($pageVars);
            $res->post_template[] = $page_model->showLastLogin($pageVars);
        } else if ($pageVars['route']['action'] == 'post-new-job') {
            $res->post_template[] = $page_model->showPostNewJob($pageVars);
            $res->post_template[] = $page_model->showLastLogin($pageVars);
        } else if ($pageVars['route']['action'] == 'show-edit-job') {
            $res->post_template[] = $page_model->showEditJob($pageVars);
            $res->post_template[] = $page_model->showLastLogin($pageVars);
        } else if ($pageVars['route']['action'] == 'my-post-jobs') {
            $res->post_template[] = $page_model->showMyPostJob($pageVars);
            $res->post_template[] = $page_model->showLastLogin($pageVars);
        } else if ($pageVars['route']['action'] == 'save-job') {
            $data = $page_model->savePostNewJob($pageVars);
            \ISOPHP\js_core::$console->log('Job Save Data', $data);
            $res->type = null;
            return $res;
        } else if ($pageVars['route']['action'] == 'edit-job') {
            $data = $page_model->savePostEditJob($pageVars);
            \ISOPHP\js_core::$console->log('Job Edit Data', $data);
            $res->type = null;
            return $res;
        } else if ($pageVars['route']['action'] == 'apply-job') {
            $data = $page_model->applyToJob($pageVars);
            \ISOPHP\js_core::$console->log('Add Apply-Job Data', $data);
            $res->type = null;
            return $res;
        } else if ($pageVars['route']['action'] == 'applicant-profile') {
            $data = $page_model->showApplicantProfile($pageVars);
            \ISOPHP\js_core::$console->log('Show Applicant-Profile Data', $data);
            $res->type = null;
            return $res;
        } else if ($pageVars['route']['action'] == 'invitation') {
            $data = $page_model->inviteForInterview($pageVars);
            \ISOPHP\js_core::$console->log('Invite applicants for interview', $data);
            $res->type = null;
            return $res;
        } else {
            $res->post_template[] = $page_model->showJobList($pageVars);
        }
        
        //$res->post_template[] = $page_model->getUserData($pageVars);
        $res->post_template[] = $page_model->showLastLogin($pageVars);
        $res->post_template[] = $page_model->bindButtons();
        \ISOPHP\js_core::$console->log('JobList Con', $res);
        $res->post_template[] = $default_page_model->bindMenu();

        /*
                if ($pageVars['route']['action'] == 'details') {
                    $res->page = $page;
                    $res->view = 'JobList.php';
                    $res->type = 'view';
                    $res->view_control = 'JobList';
                    $res->post_template = array();
                    $res->post_template[] = $page_model->showJobDetails($pageVars);
                    $res->post_template[] = $page_model->bindButtons();
                    \ISOPHP\js_core::$console->log('JobList Con', $res);
                    return $res;
                }

                if ($pageVars['route']['action'] == 'profile') {
                    $res->page = $page;
                    $res->view = 'JobDetails.php';
                    $res->type = 'view';
                    $res->view_control = 'JobList';
                    $res->post_template = array();
                    $res->post_template[] = $page_model->showEmployerDetails($pageVars);
                    $res->post_template[] = $page_model->bindButtons();
                    \ISOPHP\js_core::$console->log('Employer Con', $res);
                    return $res;
                }

                if ($pageVars['route']['action'] == 'show-to-user') {
                    $res->page = $page;
                    $res->view = 'JobList.php';
                    $res->type = 'view';
                    $res->view_control = 'JobList';
                    $res->post_template = array();
                    $res->post_template[] = $page_model->showJobListToUser($pageVars);
                    $res->post_template[] = $page_model->showLastLogin($pageVars);
                    $res->post_template[] = $page_model->bindButtons();
                    \ISOPHP\js_core::$console->log('Job List template: ', $res);
                    $res->post_template[] = $default_page_model->bindMenu();
                    return $res;
                }

                if ($pageVars['route']['action'] == 'save-favorite') {
                    $res->page = $page;
                    $res->view = 'JobList.php';
                    $res->type = 'view';
                    $res->view_control = 'JobList';
                    $res->post_template = array();
                    $res->post_template[] = $page_model->saveFavorite($pageVars);
                    $res->post_template[] = $page_model->showJobListToUser($pageVars);
                    $res->post_template[] = $page_model->showLastLogin($pageVars);
                    $res->post_template[] = $page_model->bindButtons();
                    \ISOPHP\js_core::$console->log('Save favorite', $res);
                    $res->post_template[] = $default_page_model->bindMenu();
                    return $res;
                }

                if ($pageVars['route']['action'] == 'show-user-favorite') {
                    $res->page = $page;
                    $res->view = 'JobList.php';
                    $res->type = 'view';
                    $res->view_control = 'JobList';
                    $res->post_template = array();
                    $res->post_template[] = $page_model->showFavoriteListToUser($pageVars);
                    $res->post_template[] = $page_model->showLastLogin($pageVars);
                    $res->post_template[] = $page_model->bindButtons();
                    \ISOPHP\js_core::$console->log('Show favorite', $res);
                    $res->post_template[] = $default_page_model->bindMenu();
                    return $res;
                }*/

        return $res;

    }

}


// WEBPACK FOOTER //
// app/JobList/Controller/JobListController.php